import React from 'react';



const SearchFooter = () => {
  return (
    
        
        <div className="footer">
          <ul className="footer-links">
            <li><a href="https://hn.algolia.com/about">About</a></li>
            <li><a href="https://hn.algolia.com/settings">Setting</a></li>
            <li><a href="https://hn.algolia.com/help">Help</a></li>
            <li><a href="https://hn.algolia.com/api">API Documentation</a></li>
            <li><a href="/">Hacker News</a></li>
            <li><a href="https://github.com/algolia/hn-search">Fork/Contrybute</a></li>
            <li><a href="https://hn.algolia.com/cool_apps">Cool Apps</a></li>
          </ul> 
        </div>
      
  );
}


export default SearchFooter;